var compressImage = function compressImage() {
  throw new Error('Uni API: compressImage不支持');
};

export default compressImage;